import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeApp, getApp, getApps } from "firebase/app";
import { APP_ENV } from "./config";

let firebaseConfig = {};

if (APP_ENV === "prod") {
  firebaseConfig = {
    apiKey: "AIzaSyAlm8PnimWaSJcvDpgSgLfoGaGw6FwnAXs",
    authDomain: "csmg-a0cd2.firebaseapp.com",
    projectId: "csmg-a0cd2",
    storageBucket: "csmg-a0cd2.appspot.com",
    messagingSenderId: "993717203711",
    appId: "1:993717203711:web:ea7fd8b20da1c55fe412ca",
  };
  
 } else if (APP_ENV === "stage") {
  firebaseConfig = {
    apiKey: "AIzaSyC0XKkyYC6Ila4Evm5e9Ly0RZyPLSY0UXY",
    authDomain: "stageptio.firebaseapp.com",
    projectId: "stageptio",
    storageBucket: "stageptio.firebasestorage.app",
    messagingSenderId: "272525538341",
    appId: "1:272525538341:web:9a2f0f5d04365f05397bcc",
    measurementId: "G-KW3CLC48EL"
 }
//   firebaseConfig = {
//     apiKey: "AIzaSyAFp7P0dBmLVnXCoru1tNQzWcFWQnuXrzc",
//     authDomain: "proteams-stage.firebaseapp.com",
//     projectId: "proteams-stage",
//     storageBucket: "proteams-stage.firebasestorage.app",
//     messagingSenderId: "177294488552",
//     appId: "1:177294488552:web:466d0e15c05d11cde62a5d",
//     measurementId: "G-4CQ61QTEQ7"
//  }
} else if (APP_ENV === "uat") {
  firebaseConfig = {
    apiKey: "AIzaSyAQXGZT0DHRed156u4kUus1ngL3tmhT11E",
    authDomain: "uat-ptio.firebaseapp.com",
    projectId: "uat-ptio",
    storageBucket: "uat-ptio.firebasestorage.app",
    messagingSenderId: "745235822171",
    appId: "1:745235822171:web:153a025a6781e9e93e717e",
    measurementId: "G-D1R2S797LG"
  };
} else {
  firebaseConfig = {
    apiKey: "AIzaSyCQu0ku4myhKsSAsQ5BX6vseHJ9bPCyAvc",
    authDomain: "csmg-dev-dc546.firebaseapp.com",
    projectId: "csmg-dev-dc546",
    storageBucket: "csmg-dev-dc546.appspot.com",
    messagingSenderId: "301736105925",
    appId: "1:301736105925:web:9abf7ed2b39c9b0e85ddac",
    measurementId: "G-BW78JG2P7G",
  };
}

let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}


const firebase_auth = getAuth(app);
const firebase = getFirestore(app);
const firebase_storage = getStorage(app);

export { app, firebase_auth, firebase, firebase_storage };